module.exports = __webpack_public_path__ + "img/rmz-historia.7148b217.png";